export default __webpack_public_path__ + "static/photo5usluge-14d4aadbcc87166e5594943fc4ebdc29.png";